// @ts-nocheck
import 'construct-style-sheets-polyfill'; // Needed for omni-ui to work with Firefox & Safari
import { OmniStyle } from 'omni-ui';
import { OmniAppContainer } from 'omni-app-container';
import './app-layout.js';

OmniStyle.register();
OmniAppContainer.register();
